import { format } from "date-fns";
import _ from "lodash";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../../../store/actions/auditLogActions";
import { auditTypes } from "../../../../components/auditLogs/AuditTypes.js";
import { EyeIcon, PencilSquareIcon } from "@heroicons/react/20/solid";
import Tooltip from "@/common/tooltip/Tooltip";

export const AuditRow = ({ logEntry, user, viewDetails }) => {
	return (
		<tr>
			<td>
				<button
					className="btn btn-xs btn-default"
					onClick={() => viewDetails(logEntry)}
				>
					<Tooltip content="View Details">
						<EyeIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</Tooltip>
				</button>
			</td>
			<td>{_.capitalize(logEntry.action)}</td>
			<td>{auditTypes[logEntry.type]?.name}</td>
			<td>{format(new Date(logEntry.date), "do MMM yyyy HH:mm")}</td>
			<td></td>
		</tr>
	);
};

const mapStateToProps = (state, ownProps) => {
	const { logEntry } = ownProps;
	const { userId } = logEntry;

	// find user who made log entry

	return {
		taxOptions: state.taxOptions,
	};
};

const mapDispatchToProps = (dispatch) => ({
	viewDetails: (item) => dispatch(ACTIONS.showAuditLogDetail({ show: true, item })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditRow);
